import { Vue } from 'vue-property-decorator'
import axios from 'axios'
import VueAxios from 'vue-axios'

import { API_URL } from '@/constants'

Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL = API_URL
